import React, { useState } from "react";
import { useLanguage } from "@/context/LanguageContext";
import { waitlistService } from "@/lib/services";
import { getQRSource, getUTM } from "@/lib/utm";
import { track } from "@/lib/analytics";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function WaitlistForm() {
  const { t } = useLanguage();
  const [email, setEmail] = useState("");
  const [touched, setTouched] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState("idle"); // idle | success | error

  const invalid = touched && !EMAIL_RE.test(email);

  const submit = async (ev) => {
    ev.preventDefault();
    setTouched(true);
    if (!EMAIL_RE.test(email)) {
      track("waitlist_submit_error", { error_type: "invalid_email" });
      return;
    }
    setSubmitting(true);
    track("waitlist_submit_attempt");
    const utm = getUTM();
    const qr = getQRSource();
    try {
      await waitlistService.signup({
        email,
        ...utm,
        restaurant_id: qr.restaurant_id || undefined,
        qr_source: qr.qr_source || undefined,
        source: qr.source || undefined,
      });
      setStatus("success");
      track("waitlist_submit_success");
    } catch (e) {
      setStatus("error");
      track("waitlist_submit_error", { error_type: "network" });
    } finally {
      setSubmitting(false);
    }
  };

  if (status === "success") {
    return (
      <div className="text-center" role="status" aria-live="polite" data-testid="waitlist-success">
        <div className="display-sm text-primary">{t("home.download.waitlistSuccess")}</div>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3 w-full max-w-md" data-testid="waitlist-form" noValidate>
      <input
        type="email"
        value={email}
        onChange={(ev) => {
          setEmail(ev.target.value);
          if (!touched && ev.target.value.length > 0) track("waitlist_form_start");
        }}
        onBlur={() => setTouched(true)}
        placeholder={t("home.download.emailPlaceholder")}
        data-testid="waitlist-email"
        className={`field-input flex-1 ${invalid ? "error" : ""}`}
        aria-invalid={invalid}
        required
      />
      <button type="submit" disabled={submitting} data-testid="waitlist-submit" className="btn-olive">
        {t("home.download.notifyMe")}
      </button>
      {status === "error" && (
        <div role="alert" aria-live="assertive" className="text-sm text-[#C0392B] mt-1 sm:absolute sm:mt-12" data-testid="waitlist-error">
          {t("home.download.waitlistError")}
        </div>
      )}
    </form>
  );
}
